import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4e558525"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "select-city"
};
const _hoisted_2 = {
  class: "columns-box"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "columns-box-title"
}, "热门城市", -1));

const _hoisted_4 = {
  class: "columns-box-content"
};
const _hoisted_5 = ["onClick"];
import { getSanyRegionCity } from '@/api';
import { reactive, ref, onMounted } from 'vue'; // import { areaList } from '@vant/area-data';

import { hotCityList } from './type'; // import { getSanyRegionCity } from '@/api';

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectCity',
  emits: ['close', 'confirm'],

  setup(__props, {
    emit: emits
  }) {
    const columnsList = ref(hotCityList);
    const customFieldName = {
      text: 'name'
    }; // const columns = ref([
    //   { id: 1, name: 'a' },
    //   { id: 2, name: 'b' },
    //   { id: 3, name: 'c' },
    //   { id: 4, name: 'd' },
    //   { id: 5, name: 'e' },
    // ]);

    const columns = ref([// 第一列
    {
      values: [],
      defaultIndex: 0
    }, // 第二列
    {
      values: [],
      defaultIndex: 0
    }, // 第三列
    {
      values: [],
      defaultIndex: 0
    }, // 第三列
    {
      values: ['']
    }]);
    onMounted(() => {
      getFirstCityList().then(id => {
        return getSecondCityList(id);
      }).then(id => {
        return getThirdCityList(id);
      });
    });
    const statr = reactive({
      firstCityCategoryList: '',
      secondCityCategoryList: '',
      thirdCityCategoryList: ''
    });
    const multistage = reactive({
      oneChange: '',
      twoChange: '',
      threeChange: ''
    });
    const disposable = ref(true);

    const determine = value => {
      if (value.length) {
        value.forEach((item, index) => {
          if (!index) {
            statr.firstCityCategoryList = item.name;
          } else if (index === 1) {
            statr.secondCityCategoryList = item.name;
          } else if (index === 2) {
            statr.thirdCityCategoryList = item.name;
          }
        });
        emits('confirm', statr, value);
      }
    };

    const confirmHandle = item => {
      item.data.forEach((item, index) => {
        if (!index) {
          statr.firstCityCategoryList = item.name;
        } else if (index === 1) {
          statr.secondCityCategoryList = item.name;
        }
      });
      statr.thirdCityCategoryList = '';
      emits('confirm', statr, item.data);
    };

    const getFirstCityList = () => {
      return getSanyRegionCity({
        IS_INPUT: {
          CODE: '',
          LEVEL: '1'
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any

      }).then(res => {
        columns.value[0].values = res.data.ET_LIST.map(item => ({
          id: item.ID,
          name: item.CODE_DESC,
          code: item.CODE
        }));
        return columns.value[0].values[0].code;
      });
    };

    const getSecondCityList = id => {
      return getSanyRegionCity({
        IS_INPUT: {
          CODE: id,
          LEVEL: '2'
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any

      }).then(res => {
        columns.value[1].values = res.data.ET_LIST.map(item => ({
          id: item.ID,
          name: item.CODE_DESC,
          code: item.CODE
        }));
        return columns.value[1].values[0].code;
      });
    };

    const getThirdCityList = id => {
      return getSanyRegionCity({
        IS_INPUT: {
          CODE: id,
          LEVEL: '3'
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any

      }).then(res => {
        columns.value[2].values = res.data.ET_LIST.map(item => ({
          id: item.ID,
          name: item.CODE_DESC,
          code: item.CODE
        }));

        if (disposable.value) {
          columns.value.forEach((item, index) => {
            if (!index) {
              multistage.oneChange = item.values[0].code;
            } else if (index === 1) {
              multistage.twoChange = item.values[0].code;
            } else if (index === 2) {
              multistage.threeChange = item.values[0].code;
            }
          });
        }

        disposable.value = false;
      });
    };

    const pickerChange = val => {
      console.log(multistage);
      val.forEach((item, index) => {
        if (!index) {
          console.log(item.code);
          const code = item.code;

          if (code !== multistage.oneChange) {
            getSecondCityList(code).then(id => {
              return getThirdCityList(id);
            });
            multistage.oneChange = code;
            return;
          }
        } else if (index === 1) {
          const code = item.code;

          if (code !== multistage.oneChange) {
            getThirdCityList(code);
            multistage.twoChange = code;
            return;
          }
        }
      });
    };

    return (_ctx, _cache) => {
      const _component_van_picker = _resolveComponent("van-picker");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_picker, {
        title: "",
        columns: columns.value,
        "columns-field-names": customFieldName,
        onConfirm: determine,
        onCancel: _cache[0] || (_cache[0] = $event => emits('close')),
        onChange: pickerChange
      }, {
        "columns-top": _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnsList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "columns-content",
            onClick: $event => confirmHandle(item)
          }, _toDisplayString(item.name), 9, _hoisted_5);
        }), 128))])])]),
        _: 1
      }, 8, ["columns"])]);
    };
  }

});